import isNil from 'lodash/isNil';
import React from 'react';
import { useController } from 'react-hook-form';
import RSelect from 'react-select';
import { MultiFields } from 'shared/constants/fields';
import { toSelectOptions } from 'shared/utils/form';
import { isEmptyString } from 'shared/utils/functions';
import { reactSelectStyle } from './styles';

/**
 * @type {import('./types').FieldTransformStrategy}
 */
const transform = {
  fromServer(value) {
    return value;
  },
  toServer(value, { field }) {
    const { fieldType } = field;
    const isEmpty = isEmptyString(value) || isNil(value);
    const isMulti = MultiFields.includes(fieldType);

    if (isEmpty) return isMulti ? [] : null;
    return isMulti ? value.map((v) => v.value) : value.value;
  },
  defaultValue(value) {
    return toSelectOptions(value);
  },
};

const Select = React.memo(function Select({
  name,
  control,
  required,
  fieldType,
  readOnly,
  config = {},
}) {
  const {
    field: { onChange, value, ref },
  } = useController({ name, control, rules: { required } });
  const options = toSelectOptions(config?.options || []);
  const isMulti = MultiFields.includes(fieldType);
  const customStyles = reactSelectStyle(false, isMulti);

  return (
    <RSelect
      inputId={name}
      inputRef={ref}
      options={options}
      defaultValue={value}
      maxMenuHeight={200}
      styles={customStyles}
      onChange={onChange}
      isDisabled={readOnly}
      isMulti={isMulti}
      isSearchable
      isClearable
    />
  );
});

Select.transform = transform;
export default Select;
